import { render, staticRenderFns } from "./AppChatMessageInformationRequestPreview.vue?vue&type=template&id=cb08f54e&scoped=true"
import script from "./AppChatMessageInformationRequestPreview.vue?vue&type=script&lang=js"
export * from "./AppChatMessageInformationRequestPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb08f54e",
  null
  
)

export default component.exports